import React from "react";

const CoachingPhilosophySection = ({ isEditing, value, onChange }) => {
  return (
    <div className="bg-white p-6 border border-[#E6E6E6]">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-[11px] font-bold text-[#3C3C3C]">COACHING PHILOSOPHY</h2>
      </div>
      <div className="mb-6">
        <textarea
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder="Share how you inspire, guide, and develop athletes both on and off the field."
          className="w-full h-32 px-3 py-2 bg-[#F8F9FB] border border-gray-300 rounded-md text-[14px] font-medium resize-none focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          disabled={!isEditing}
        />
      </div>
    </div>
  );
};

export default CoachingPhilosophySection;

